import React from "react"
import { LineChart } from "react-chartkick";
import { toISODate } from "../helpers"

const StartedFinishedTimeChart = ({ poms }) => {
  const startTimesByDay = {};
  const stopTimesByDay = {};
  poms.forEach(pom => {
    const date = toISODate(pom.stop);

    // const stoppedAt = pom.stop.hour + pom.stop.minute / 60;
    const stoppedAt = pom.stop.getHours() + pom.stop.getMinutes() / 60;
    // const stoppedAtPercent = stoppedAt / 24;
    stopTimesByDay[date] = Math.max(stoppedAt, stopTimesByDay[date] || 0);

    const startedAt = pom.start.getHours() + pom.start.getMinutes() / 60;
    startTimesByDay[date] = Math.min(startedAt, startTimesByDay[date] || 25);
  });

  return (
    <div>
      <LineChart
        data={[
          { name: "started at", data: startTimesByDay, color: "green" },
          { name: "stopped at", data: stopTimesByDay, color: "red" }
        ]}
        xtitle="Date"
        ytitle="Time"
        curve={false}
        download={"stoptimesbyday"}
        title={"Started and Stopped Time by Day"}
        max={24}
        min={8}
      />
      {/*<pre>{JSON.stringify(stopTimesByDay, null, 2)}</pre>*/}
    </div>
  );
}

export default StartedFinishedTimeChart;


// WEBPACK FOOTER //
// ./src/charts/StartedFinishedTimeChart.js